import React from 'react';

import teaser from '@/assets/videos/teaser.mp4';

import './Teaser.css';

const Teaser: React.FC = () => {
  return (
    <div className="teaser">
      <video
        src={teaser}
        className="teaser__video"
        autoPlay
        muted
        loop
        playsInline
        data-object-fit="cover"
        data-wf-ignore="true"
      />
    </div>
  );
};

export default Teaser;
